export default "__VITE_ASSET__BhXADkZt__"